<template>
  <div class="expired">
    <button
      class="btn btn-outline-light btn-sm btn-logout rounded-pill"
      @click="logout"
    >
      SAIR
    </button>
    <div class="container text-center text-light pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <img
            src="@/assets/images/expired/logo-tagline.png"
            class="img-fluid"
          />
        </div>

        <div class="col-12">
          <img src="@/assets/images/expired/benefits.png" class="img-fluid" />
        </div>

        <div class="col-lg-6 mt-4">
          <a
            href="https://pay.hotmart.com/G10772356J?off=ivhfo59w&bid=1727705653397&src=pagina&sck=venda_no_desktop"
            class="btn btn-primary rounded-pill btn-lg font-weight-bold px-5"
            >Assinar por 12x R$ 29,00</a
          >

          <small class="d-block p-4"
            >Ao realizar sua inscrição, você passa a ter acesso aos materiais
            correspondentes ao mês da sua assinatura atual e a qualquer momento
            você pode solicitar o cancelamento da sua renovação
            automática.</small
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "login" });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.expired {
  background: url(http://guerrilhaway.com.br/wp-content/uploads/2019/08/Landing_Page-2-co%CC%81pia.jpg)
    top center repeat;
  min-height: 100vh;

  .btn-logout {
    position: absolute;
    top: 12px;
    right: 12px;
    padding: 6px 12px;
  }
}
</style>
